import React from 'react';
import { connect } from 'react-redux';
import { Avatar } from '@shoflo/polymer/components/Avatar/Avatar';
import AccountSettings from 'components/AccountSettings';
import StyledModalHeader from 'components/modal/StyledModalHeader';
import StyledModalBody from 'components/modal/StyledModalBody';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleDown,
  faCog,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';

import { showModal, clearModal } from 'actions';

import { updateUser, createPasswordResetToken } from 'actions/User';

import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal
} from 'reactstrap';

import Tooltip from 'components/Tooltip';

const StyledDropdownToggle = styled(DropdownToggle)`
  display: flex;
  align-items: center;
`;
const DropdownUsername = styled.span`
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 16px;
  margin-left: 10px;
  margin-right: 3px;
  color: #262d36;
`;
const DropdownIcon = styled(FontAwesomeIcon)`
  font-size: 16px;
`;

const UserDropdown = ({
  user,
  onLogoutClick,
  updateUser,
  createPasswordResetToken,
  updateUserPasswordFailed,
  showModal,
  clearModal,
  modalOpen
}) => {
  if (!user) return null;

  return (
    <React.Fragment>
      <UncontrolledDropdown nav inNavbar>
        <StyledDropdownToggle nav>
          <Avatar user={user} hideTooltip />
          <Tooltip
            id="account-nav"
            title="Access account settings and log out"
          />
          <DropdownUsername
            className="dd-privacy-mask"
            data-testid="userAccountDropDown"
            aria-describedby="tip-account-nav"
          >
            {`${user.firstName} ${user.lastName}`}{' '}
            <FontAwesomeIcon icon={faAngleDown} />
          </DropdownUsername>
        </StyledDropdownToggle>

        <DropdownMenu end>
          <Tooltip
            id="account-settings"
            placement="left"
            title="Change your name, password, and other account settings"
          />
          <DropdownItem
            data-testid="accountSettings"
            onClick={showModal.bind(null, 'ACCOUNT_SETTINGS')}
            aria-describedby="tip-account-settings"
          >
            <DropdownIcon icon={faCog} /> Account settings
          </DropdownItem>

          <Tooltip
            id="account-logout"
            placement="left"
            title="Log out of Shoflo"
          />
          <DropdownItem
            data-testid="accountLogout"
            onClick={onLogoutClick}
            aria-describedby="tip-account-logout"
          >
            <DropdownIcon icon={faSignOutAlt} /> Logout
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>

      <Modal size="md" isOpen={modalOpen}>
        <StyledModalHeader toggle={clearModal.bind(null, 'ACCOUNT_SETTINGS')}>
          Edit account settings
        </StyledModalHeader>
        <StyledModalBody>
          {modalOpen && (
            <AccountSettings
              {...{ user, updateUserPasswordFailed }}
              onSendResetPassToken={createPasswordResetToken}
              onSubmit={(userId, formValues) => {
                handleSubmit(userId, formValues, updateUser);
              }}
              onCancel={clearModal.bind(null, 'ACCOUNT_SETTINGS')}
            />
          )}
        </StyledModalBody>
      </Modal>
    </React.Fragment>
  );
};

const handleSubmit = (userId, formValues, submit) => {
  const { currentPassword, newPassword } = formValues;
  let { fullName } = formValues;

  fullName = fullName.trim().split(' ');

  const firstName = fullName[0];
  fullName.shift();
  const lastName = fullName.join(' ');

  let userPayload = {
    firstName: firstName,
    lastName: lastName
  };

  if (currentPassword && newPassword) {
    userPayload = {
      currentPassword: currentPassword,
      newPassword: newPassword,
      ...userPayload
    };
  }

  submit(userId, userPayload);
};

export default connect(
  ({ updateUserPasswordFailed, modal }) => {
    const modalOpen = modal && modal.type === 'ACCOUNT_SETTINGS';

    return {
      updateUserPasswordFailed,
      modalOpen
    };
  },
  {
    updateUser,
    createPasswordResetToken,
    showModal,
    clearModal
  }
)(UserDropdown);
